var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.647 11.9685V8.7307C14.647 5.8161 12.2855 3.45459 9.37093 3.45459H8.66869C5.75409 3.45459 3.39258 5.8161 3.39258 8.7307V11.9685C2.03161 12.2108 1 13.3978 1 14.8209V15.2124C1 16.8158 2.29883 18.1146 3.90217 18.1146H14.1375C15.7408 18.1146 17.0396 16.8158 17.0396 15.2124V14.8209C17.0396 13.3916 16.008 12.2046 14.647 11.9685Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51855 3.57902V2.49769C7.51855 1.67117 8.18972 1 9.01625 1C9.84278 1 10.5139 1.67117 10.5139 2.49769V3.57902",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5081 18.1211V19.2024C10.5081 20.0289 9.83692 20.7001 9.01039 20.7001C8.18386 20.7001 7.5127 20.0289 7.5127 19.2024V18.1211",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/Alarm.a4bb17aa367eaa3be6465d60c5f475d3.svg";
export { ForwardRef as ReactComponent };